import { Slot } from '@radix-ui/react-slot';
import { cn } from '@utils/cn';

import { type InformationDescriptionProps } from './types';

const InformationDescription = ({
  asChild = false,
  className,
  ...props
}: InformationDescriptionProps) => {
  const Component = asChild ? Slot : 'p';

  return (
    <Component
      className={cn('text-balance text-muted-foreground', className)}
      {...props}
    />
  );
};

export { InformationDescription };
